import React from 'react';
import { Text, Toggle } from '@spark';

/**
 * "Compare SpecificAI results to this model" header (Figma
 * .ModelSetup-CompareHeader): title + description on the left, toggle on the
 * right. The compare body (children) renders only while the toggle is on.
 * Persisted as comparison_mode + option teacher/none.
 *
 * hideIntro (re-eval modal) skips the title/description and replaces the
 * toggle with a left-aligned status line (statusLabel).
 */
const ComparisonSwitch = ({
    showResponseParser,
    onChange,
    role,
    readOnly = false,
    hideIntro = false,
    statusLabel = 'Comparing against a commercial model',
    children,
}) => (
    <>
        <div className={`model-setup-compare-header${hideIntro ? ' model-setup-compare-header--status-only' : ''}`}>
            {!hideIntro && (
                <div className="model-setup-compare-header__copy fs-unmask">
                    <Text variant="base-semibold" color="primary" as="div">
                        Compare SpecificAI results to this model
                    </Text>
                    <Text variant="detail-regular" color="secondary" as="div">
                        {showResponseParser
                            ? 'See what this model returns on a sample row, then map the prediction.'
                            : 'Run a sample, map the commercial model output, then choose what to ignore when scoring.'}
                    </Text>
                </div>
            )}
            <div className="model-setup-compare-header__controls fs-unmask">
                {hideIntro ? (
                    <Text variant="base-regular" color="secondary" as="span">
                        {statusLabel}
                    </Text>
                ) : (
                    <Toggle
                        active={showResponseParser}
                        disabled={readOnly || role === 'Viewer'}
                        onChange={(e) => onChange?.(e.target.checked)}
                        aria-label="Compare SpecificAI results to this model"
                    />
                )}
            </div>
        </div>
        {(showResponseParser || hideIntro) && children}
    </>
);

export default ComparisonSwitch;
